import { useTranslation } from "react-i18next";
import spmlogo from "../../resources/img/spmlogo.png";
import Spinner from "../spinner/Spinner";

const Title = ({ errorMessage, loading }) => {
  const { t: t } = useTranslation();
  const spinner = loading && <Spinner />;

  return (
    <div className="w3-display-container content-container">
      <div className="w3-display-middle w3-center form-display">
        {errorMessage}
        {spinner}
        <div className="w3-panel w3-card-4 w3-theme-l3 w3-center">
          <h1>{t("title_welcome")}</h1>
          <img src={spmlogo} alt="SPM logo" className="spm-logo" />
        </div>
        <div className="w3-panel w3-card-4 w3-center disclaimer-background">
          <h2 className="disclaimer-text">
            {t("title_disclaimer")} {t("title_disclaimer_2")}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Title;
